import { render, staticRenderFns } from "./core.vue?vue&type=template&id=5bf82227&scoped=true"
var script = {}
import style0 from "./core.vue?vue&type=style&index=0&id=5bf82227&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf82227",
  null
  
)

export default component.exports